import useUserPermissions from "../../../../../../../common/utils/user/permissions/use-user-permissions";
import cargoCompanyListingUserPermissionDefinition from "./cargo-company-listing-user-permission";

const useCargoCompanyListingUserPermissions = () => {
  return useUserPermissions(cargoCompanyListingUserPermissionDefinition);
};

export default useCargoCompanyListingUserPermissions;
